// extracted by mini-css-extract-plugin
export var container = "_26-0";